import script from "./PriceTag2.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceTag2.vue?vue&type=script&setup=true&lang=js"

import "./PriceTag2.vue?vue&type=style&index=0&id=5d807444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d807444"]])

export default __exports__